import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCampaignMutation } from "./useCampaignMutation";
import RetailNotification from "components/Notification";

export const useRegionState = (data: any, settings: any) => {
  const { t } = useTranslation();

  const { changeValue } = useCampaignMutation("campaign_regions", data?.id);

  const [regionsVisible, setRegionsVisible] = useState(false);

  const [regionType, setRegionType] = useState<
    "ALL_REGIONS" | "SELECTED_REGIONS" | string
  >("");

  const [selectedRegions, setSelectedRegions] = useState<number[]>([]);

  const activeRegions = data?.regions?.filter(
    (region: any) => region.status === "ACTIVE"
  );

  const regionStateSetFromData = () => {
    setRegionType(
      activeRegions?.length === settings?.regions?.length
        ? "ALL_REGIONS"
        : "SELECTED_REGIONS"
    );
    setSelectedRegions(
      activeRegions.map((region: any) => region?.region_id) || []
    );
  };

  const openMultiRegion = () => {
    regionStateSetFromData();
    setRegionsVisible(true);
  };

  const handleMultiRegionChange = ({ target }: any) =>
    setRegionType(target.value);

  const onMultiRegionCancel = () => setRegionsVisible(false);

  const onMultiRegionOk = async () => {
    try {
      await changeValue({
        status: "ACTIVE",
        id:
          regionType === "ALL_REGIONS"
            ? settings?.regions?.map((region: any) => region?.id)
            : selectedRegions,
      });
      RetailNotification.showNotification(
        "success",
        "",
        t("pages.acc.campaignDetails.regionsUpdated")
      );
    } catch (e) {
      RetailNotification.showNotification(
        "error",
        "",
        t("components.campaignForm.firstStep.errorStates.generalErr")
      );
    } finally {
      onMultiRegionCancel();
    }
  };

  return {
    regionsVisible,
    selectedRegions,
    setSelectedRegions,
    regionType,
    setRegionType,
    activeRegions,
    openMultiRegion,
    handleMultiRegionChange,
    onMultiRegionCancel,
    onMultiRegionOk,
  };
};
